import React from 'react';
import SubjectPage from '../structure/SubjectPage';
import Accordions from '../../../components/Dropdowns';

const Java = ({ branch = "CSE", semester = "4th Semester" }) => {
  const accordionContent = [
    <div key="1" className="p-4">
      <p>Overview and characteristics of Java, Java program Compilation and Execution Process Organization of the Java Virtual Machine, JVM as an interpreter and emulator, Instruction Set, class File Format, Verification, Class Area, Java Stack, Heap, Garbage Collection. Security Promises of the JVM, Security Architecture and Security Policy. Class loaders and security aspects, sandbox model.</p>
    </div>,
    <div key="2" className="p-4">
      <p>Java Fundamentals, Data Types & Literals Variables, Wrapper Classes, Arrays, Arithmetic Operators, Logical Operators, Control of Flow, Classes and Instances, Class Member Modifiers Anonymous Inner Class Interfaces and Abstract Classes, inheritance, throw and throws clauses, user defined Exceptions, The String Buffer Class, tokenizer, applets, Life cycle of applet and Security concerns.</p>
    </div>,
    <div key="3" className="p-4">
      <p>Threads: Creating Threads, Thread Priority, Blocked States, Extending Thread Class, Runnable Interface, Starting Threads, Thread Synchronization, Synchronize Threads, Sync Code Block, Overriding Synced Methods, Thread Communication, wait, notify and notify all. AWT Components, Component Class, Container Class, Layout Manager Interface Default Layouts, Insets and Dimensions, Border Layout, Flow Layout, Grid Layout, Card Layout Grid Bag Layout AWT Events, Event Models, Listeners, Class Listener, Adapters, Action Event Methods Focus Event Key Event, Mouse Events, Window Event.</p>
    </div>,
    <div key="4" className="p-4">
      <p>Input/Output Stream, Stream Filters, Buffered Streams, Data input and Output Stream, Print Stream Random Access File, JDBC (Database connectivity with MS-Access, Oracle, MS-SQL Server), Object serialization, Sockets, development of client Server applications, design of multithreaded server. Remote Method invocation, Java Native interfaces, Development of a JNI based application. Collection API Interfaces, Vector, stack, Hashtable classes, enumerations, set, List, Map, Iterators.</p>
    </div>
  ];

  const tabData = [
    {
      id: 'syllabus',
      label: 'Syllabus',
      content: <Accordions accordionContent={accordionContent} />,
    },
    {
      id: 'notes',
      label: 'Notes',
      content: null, // Managed by SubjectPage
    },
    {
      id: 'important',
      label: 'Important Questions',
      content: null, // Managed by SubjectPage
    },
    {
      id: 'books',
      label: 'Books',
      content: null, // Managed by SubjectPage
    },
    {
      id: 'PYQ',
      label: 'PYQ',
      content: null, // Managed by SubjectPage
    },
    {
      id: 'videos',
      label: 'Video Lectures',
      content: null, // Managed by SubjectPage
    }
  ];

  return (
    <SubjectPage
      subjectName="Programming In Java"
      subjectKey="java"
      branch={branch}
      semester={semester}
      accordionContent={accordionContent}
      tabData={tabData}
      adminEmail="snaped4338@gmail.com"
      firestoreCollections={{
        notes: 'JavaNotes',
        videos: 'JavaVideos'
      }}
    />
  );
};

export default Java;
